// src/components/cart/CheckoutAuthModal.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { X, UserPlus, LogIn } from "lucide-react";

export function CheckoutAuthModal({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-5"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </button>

        <h2 className="font-display text-xl text-[#0F172A]">Continue to checkout</h2>
        <p className="mt-2 text-sm text-slate-500">
          Sign in or create a free account to confirm your booking and go live.
        </p>

        <div className="mt-6 space-y-3">
          <button
            onClick={() => navigate("/register")}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-[#EB4A2D] px-4 py-3 text-sm font-semibold text-white transition-transform hover:scale-[1.02]"
          >
            <UserPlus className="h-4 w-4" /> New to Adroj
          </button>
          <button
            onClick={() => navigate("/login")}
            className="flex w-full items-center justify-center gap-2 rounded-full border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
          >
            <LogIn className="h-4 w-4" /> Login
          </button>
        </div>
      </div>
    </div>
  );
}